import { InvoiceTax } from "./invoice-tax";
import { TaxpayerType } from "./taxpayer-type";
import { InvoiceCashDeskItem } from "./invoice-cash-desk-item";
import { InvoiceLabelType } from "./invoice-label-type";
import { InvoiceCashDeskPayment } from "./invoice-cash-desk-payment";
import { ClientSearch } from "./client-search";
import { ServiceFilter } from "./service-filter";
import { InvoicePoint } from "./invoice-point";
import { VirtualWalletFilter } from "./virtual-wallet-filter";

export class InvoiceCashDesk {
  InvoiceTaxes: InvoiceTax[];
  InvoiceCashDeskItems: InvoiceCashDeskItem[];
  InvoiceLabelType: InvoiceLabelType;
  InvoiceCashDeskPaymentCash: InvoiceCashDeskPayment;
  InvoiceCashDeskPaymentDebitCard: InvoiceCashDeskPayment;
  InvoiceCashDeskPaymentCreditCard: InvoiceCashDeskPayment;
  InvoiceCashDeskPaymentCheck: InvoiceCashDeskPayment;
  InvoiceCashDeskPaymentWireTransfer: InvoiceCashDeskPayment;
  InvoiceCashDeskPaymentQrLink: InvoiceCashDeskPayment;
  VirtualWalletTransactionId: string | null;
  VirtualWalletOriginalAmount: number | null;
  Service: ServiceFilter;
  ServiceManual: ServiceFilter;
  InvoicePoint: InvoicePoint;
  TaxpayerType: TaxpayerType;
  InvoiceId?: number;
  InvoiceParentId?: number;
  Amount?: number;
  Number?: number;
  Description: string;
  Observation: string;
  Document: string;
  ClientSearch: ClientSearch;
  PatientId?: number;
  Address: string;
  BusinessName: string;
  Atention: string;
  InvoiceTypeId: number;
  MedicalAppointmentId?: number;
  TaxNumber?: number;
  EquipmentId?: number;
  CashDeskInvoicePointId?: number;
  InvoiceNumberBookId?: number;
  InvoiceNumberBookTypeId: number;
  CashDeskOpenId?: number;
  ValorizationId?: number;
}

export class InvoiceCashDeskTotals {
  private invoiceCashDesk: InvoiceCashDesk;

  constructor(invoiceCashDesk: InvoiceCashDesk) {
    this.invoiceCashDesk = invoiceCashDesk;
  }

  getTotalTaxAmount(): number {
    let totalTax = 0;
    this.invoiceCashDesk.InvoiceTaxes.forEach((item) => {
      totalTax += this.getTaxAmount(item);
    });
    return Math.round(totalTax * 1e2) / 1e2;
  }

  getTaxAmount(invoiceTax: InvoiceTax): number {

    return (
      Math.round(
        Number(
          (invoiceTax.Aliquot / 100) *
            Number(
              invoiceTax.AmountBase > 0
                ? invoiceTax.AmountBase
                : this.invoiceCashDesk.Amount
            )
        ) * 1e2
      ) / 1e2
    );
  }

  getTotalAmount(): number {
    return (
      Math.round(
        (Number(this.invoiceCashDesk.Amount) + this.getTotalTaxAmount()) * 1e2
      ) / 1e2
    );
  }

  getTotalPayment(): number {
    let totalPayment = 0;

    if (
      this.invoiceCashDesk.InvoiceCashDeskPaymentCash &&
      this.invoiceCashDesk.InvoiceCashDeskPaymentCash.PaymentAmount > 0
    ) {
      totalPayment =
        totalPayment +
        Number(this.invoiceCashDesk.InvoiceCashDeskPaymentCash.PaymentAmount);
    }

    if (
      this.invoiceCashDesk.InvoiceCashDeskPaymentCheck &&
      this.invoiceCashDesk.InvoiceCashDeskPaymentCheck.PaymentAmount > 0
    ) {
      totalPayment =
        totalPayment +
        Number(this.invoiceCashDesk.InvoiceCashDeskPaymentCheck.PaymentAmount);
    }

    if (
      this.invoiceCashDesk.InvoiceCashDeskPaymentCreditCard &&
      this.invoiceCashDesk.InvoiceCashDeskPaymentCreditCard.PaymentAmount > 0
    ) {
      totalPayment =
        totalPayment +
        Number(
          this.invoiceCashDesk.InvoiceCashDeskPaymentCreditCard.PaymentAmount
        );
    }

    if (
      this.invoiceCashDesk.InvoiceCashDeskPaymentDebitCard &&
      this.invoiceCashDesk.InvoiceCashDeskPaymentDebitCard.PaymentAmount > 0
    ) {
      totalPayment =
        totalPayment +
        Number(
          this.invoiceCashDesk.InvoiceCashDeskPaymentDebitCard.PaymentAmount
        );
    }

    if (
      this.invoiceCashDesk.InvoiceCashDeskPaymentWireTransfer &&
      this.invoiceCashDesk.InvoiceCashDeskPaymentWireTransfer.PaymentAmount > 0
    ) {
      totalPayment =
        totalPayment +
        Number(
          this.invoiceCashDesk.InvoiceCashDeskPaymentWireTransfer.PaymentAmount
        );
    }

    if (
      this.invoiceCashDesk.InvoiceCashDeskPaymentQrLink &&
      this.invoiceCashDesk.InvoiceCashDeskPaymentQrLink.PaymentAmount > 0
    ) {
      totalPayment =
        totalPayment +
        Number(this.invoiceCashDesk.InvoiceCashDeskPaymentQrLink.PaymentAmount);
    }

    return Math.round(totalPayment * 1e2) / 1e2;
  }
}
